import apiHandler from "../core/apiHandler";

const fiscalPrecinctApi = apiHandler('fiscal-precincts');
export default fiscalPrecinctApi;
